<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div>
          <div class="custom-control custom-radio">
            <input type="radio" id="r1" v-model="drugsFilter" value="all" class="custom-control-input">
            <label class="custom-control-label" for="r1">Все препараты</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="r2" v-model="drugsFilter" value="noCodes" class="custom-control-input">
            <label class="custom-control-label" for="r2">Без штрих кода</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="r3" v-model="drugsFilter" value="noUteka" class="custom-control-input">
            <label class="custom-control-label" for="r3">Без uteka</label>
          </div>
        </div>

        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
        <template v-if="records && records.length">


          <table class="table table-sm table-hover mt-1">
            <thead>
            <tr>
              <th rowspan="2"></th>
              <th rowspan="2">Препарат</th>
              <th>BARCODE</th>
              <th>BARCODE</th>
              <th>BARCODE</th>
            </tr>
            <tr>
              <th v-for="s in suppliersData">{{ s }}</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(r,i) in filteredRecords">
              <tr>
                <td rowspan="2">{{ i + 1 }}</td>
                <td rowspan="2">
                  <p>{{ r.site_details[0] && r.site_details[0].text_value || 'нет названия на проекте ЛШ' }}</p>
                  <p>{{ r.title }}</p>
                </td>
                <template v-for="d in r.barcodes">
                  <td>
                    <input @change="updateRecord(r.id)" type="text" v-model="d.text_value" class="form-control">
                  </td>
                </template>
              </tr>
              <tr>
                <template v-for="s in suppliersData">
                  <td>
                    <input :placeholder="s" @change="updateRecord(r.id)" type="text"
                           v-model="r.suppliersData[s].text_value"
                           class="form-control">
                  </td>
                </template>
              </tr>
            </template>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      records: [],
      filteredRecords: [],
      drugsFilter: 'all',
      loading: false,
      suppliersData: ['eapteka', 'uteka', 'aptekamos'],
    }
  },
  created() {
    this.getRecords();
  },
  watch: {
    'drugsFilter': {
      handler: function (val, oldVal) {
        this.getSortedRecords();
      },
      deep: true
    }
  },
  methods: {
    getSortedRecords() {
      switch (this.drugsFilter) {
        case 'noUteka':
          this.filteredRecords = this.records.filter((r) => !r.suppliersData.eapteka.text_value);
          break;
        case 'noCodes':
          this.filteredRecords = this.records.filter((r) => !r.barcodes[0].text_value);
          break;
        default:
          this.filteredRecords = [...this.records];
          break;
      }
    },
    async updateRecord(id) {
      const index = this.records.findIndex((r) => r.id === id);
      if (index === -1) return;
      const {data} = await api.post('/new/nomenclature/barcodes', {
        record: this.records[index]
      })
      if (data.success) {
        const barcodes = data.details.filter((d) => d.group_alias === 'manufacturer');
        for (let i = 0; i < 3; i++) {
          if (!barcodes[i]) {
            barcodes[i] = {text_value: null}
          }
        }
        const suppliersData = data.details.reduce((acc, d) => {
          if (d.group_alias === 'suppliers_link_data') {
            acc[d.alias] = {...d}
          }
          return acc;
        }, {});
        this.suppliersData.forEach((s) => {
          if (!suppliersData[s]) {
            suppliersData[s] = {text_value: null};
          }
        })
        this.records[index].barcodes = barcodes;
        this.records[index].suppliersData = suppliersData;
        this.getSortedRecords();
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/new/nomenclature/barcodes')
      if (data.success) {
        this.records = data.records.map((r) => {
          r.barcodes = r.details.filter((d) => d.group_alias === 'manufacturer');
          for (let i = 0; i < 3; i++) {
            if (!r.barcodes[i]) {
              r.barcodes[i] = {text_value: null};
            }
          }
          r.suppliersData = r.details.reduce((acc, d) => {
            if (d.group_alias === 'suppliers_link_data') {
              acc[d.alias] = {...d}
            }
            return acc;
          }, {});
          this.suppliersData.forEach((s) => {
            if (!r.suppliersData[s]) {
              r.suppliersData[s] = {text_value: null};
            }
          })
          return r
        });
        this.getSortedRecords();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>

table.table td {
  padding: 3px;
}

p {
  font-size: 12px;
  margin-bottom: 0;
}
</style>
